import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import ProtectedRoute from './components/ProtectedRoute';
import { TicketSearchProvider } from './contexts/TicketSearchContext';
import { Helmet } from 'react-helmet';

function App() {
  return (
    <>      
    <Helmet>
      <title>TCSA GLPIWS</title>
      <link rel="icon" type="image/png" href="/favicon.png" />
    </Helmet>
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <TicketSearchProvider>
                  <Dashboard />
                </TicketSearchProvider>
              </ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
